/**
 * @generated SignedSource<<a646fbfc45f104e364861f3482a8ab28>>
 * @relayHash 12bf1a57a418c24b6af7de5212f6a303
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd17bacbe1f9f25e59a66b6ead8ba1cc12eda34d08dfcb1424953180b0f23dae

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueChangeInput = {
  issueId: string;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
  jiraTimelineInput?: JiraTimelineIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraTimelineIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  boardId: string;
  customFilterIds?: ReadonlyArray<string> | null | undefined;
  quickFilterIds?: ReadonlyArray<string> | null | undefined;
};
export type JiraIssueSearchViewContextInput = {
  expandedGroups?: JiraIssueExpandedGroups | null | undefined;
  expandedParents?: ReadonlyArray<JiraIssueExpandedParent> | null | undefined;
  topLevelItemsLoaded?: number | null | undefined;
};
export type JiraIssueExpandedGroups = {
  groupedByFieldId: string;
  groups?: ReadonlyArray<JiraIssueExpandedGroup> | null | undefined;
};
export type JiraIssueExpandedGroup = {
  fieldValue?: string | null | undefined;
  first?: number | null | undefined;
  jql: string;
};
export type JiraIssueExpandedParent = {
  first?: number | null | undefined;
  parentIssueId: string;
};
export type useGetRealtimeIssueDetailsQuery$variables = {
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  isConditionalFormattingEnabled: boolean;
  isDensityFull: boolean;
  isEditableSyncLoaded: boolean;
  isHierarchyEnabled: boolean;
  isInlineEditingEnabled: boolean;
  isLinkRelationshipFieldEnabled: boolean;
  isTimelineEnabled: boolean;
  issueAris: ReadonlyArray<string>;
  issueChanges: ReadonlyArray<JiraIssueChangeInput>;
  issueSearchInput: JiraIssueSearchInput;
  projectKey: string;
  searchViewContextInput: JiraIssueSearchViewContextInput;
  staticViewInput: JiraIssueSearchStaticViewInput;
};
export type useGetRealtimeIssueDetailsQuery$data = {
  readonly jira: {
    readonly searchViewContexts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly contexts: ReadonlyArray<{
            readonly afterIssueId: string | null | undefined;
            readonly beforeIssueId: string | null | undefined;
            readonly position: number;
            readonly sourceIssueId: string;
          }> | null | undefined;
          readonly jql?: string | null | undefined;
          readonly parentIssueId?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira_issuesByIds: ReadonlyArray<{
    readonly __id: string;
    readonly canHaveChildIssues?: boolean | null | undefined;
    readonly fieldSetsById: {
      readonly __id: string;
      readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets">;
    } | null | undefined;
    readonly issueId: string;
    readonly issueTypeField?: {
      readonly id: string;
      readonly issueType: {
        readonly hierarchy: {
          readonly level: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly parentIssueField: {
      readonly parentIssue: {
        readonly __id: string;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel_statusAndResolved">;
  } | null | undefined> | null | undefined;
};
export type useGetRealtimeIssueDetailsQuery = {
  response: useGetRealtimeIssueDetailsQuery$data;
  variables: useGetRealtimeIssueDetailsQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-view-child-issues-panel-realtime-update.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isJiraTimelineRollupsTechnicalGateEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-rollups-technical-gate.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEditableSyncLoaded"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isHierarchyEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLinkRelationshipFieldEnabled"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueChanges"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchViewContextInput"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v15 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "issueAris"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v18 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "key"
},
v20 = {
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v22 = {
  "args": [
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "canHaveChildIssues"
},
v23 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueChanges",
    "variableName": "issueChanges"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "searchViewContextInput",
    "variableName": "searchViewContextInput"
  },
  {
    "kind": "Variable",
    "name": "staticViewInput",
    "variableName": "staticViewInput"
  }
],
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "parentIssueId"
    }
  ],
  "type": "JiraIssueSearchBulkViewParentContexts"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jql"
    }
  ],
  "type": "JiraIssueSearchBulkViewGroupContexts"
},
v26 = {
  "kind": "ScalarField",
  "name": "sourceIssueId"
},
v27 = {
  "kind": "ScalarField",
  "name": "position"
},
v28 = {
  "kind": "ScalarField",
  "name": "beforeIssueId"
},
v29 = {
  "kind": "ScalarField",
  "name": "afterIssueId"
},
v30 = {
  "kind": "ScalarField",
  "name": "type"
},
v31 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v32 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v33 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v34 = {
  "kind": "ScalarField",
  "name": "name"
},
v35 = {
  "kind": "ScalarField",
  "name": "value"
},
v36 = [
  (v35/*: any*/),
  (v20/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v37 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v38 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v39 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v40 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v41 = {
  "kind": "ScalarField",
  "name": "date"
},
v42 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v43 = {
  "kind": "ScalarField",
  "name": "text"
},
v44 = {
  "condition": "isEditableSyncLoaded",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditableInIssueView"
    }
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v46 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v20/*: any*/)
  ]
},
v47 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v20/*: any*/)
  ]
},
v48 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v50 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v51 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v20/*: any*/)
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "picture"
},
v53 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v54 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v55 = [
  {
    "kind": "ScalarField",
    "name": "appType"
  }
],
v56 = {
  "kind": "ScalarField",
  "name": "isResolved"
},
v57 = {
  "kind": "ScalarField",
  "name": "relationName"
},
v58 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v59 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v60 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v61 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v62 = [
  (v20/*: any*/)
],
v63 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v62/*: any*/)
},
v64 = {
  "kind": "ScalarField",
  "name": "href"
},
v65 = {
  "concreteType": "JiraStatusField",
  "kind": "LinkedField",
  "name": "statusField",
  "plural": false,
  "selections": [
    (v51/*: any*/),
    (v20/*: any*/)
  ]
},
v66 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/)
  ],
  "type": "JiraDatePickerField"
},
v68 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v67/*: any*/),
  (v20/*: any*/)
],
v69 = [
  (v32/*: any*/),
  (v67/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v62/*: any*/),
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v70 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
          (v20/*: any*/),
          (v16/*: any*/),
          {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v21/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          (v19/*: any*/),
          (v65/*: any*/),
          {
            "concreteType": "JiraSingleSelectUserPickerField",
            "kind": "LinkedField",
            "name": "assigneeField",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v32/*: any*/),
                  (v52/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "args": (v66/*: any*/),
            "kind": "LinkedField",
            "name": "startDateViewField",
            "plural": false,
            "selections": (v68/*: any*/),
            "storageKey": "startDateViewField(viewId:\"list_default\")"
          },
          {
            "args": (v66/*: any*/),
            "kind": "LinkedField",
            "name": "endDateViewField",
            "plural": false,
            "selections": (v68/*: any*/),
            "storageKey": "endDateViewField(viewId:\"list_default\")"
          }
        ]
      },
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "aggregatedStartDateViewField",
                "plural": false,
                "selections": (v69/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "aggregatedEndDateViewField",
                "plural": false,
                "selections": (v69/*: any*/)
              }
            ],
            "type": "JiraAggregatedTimelineField"
          }
        ]
      }
    ],
    "type": "JiraTimelineVirtualField",
    "abstractKey": "__isJiraTimelineVirtualField"
  }
],
v71 = [
  (v32/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useGetRealtimeIssueDetailsQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v17/*: any*/)
                ]
              }
            ]
          },
          {
            "args": (v18/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isConditionalFormattingEnabled",
                    "variableName": "isConditionalFormattingEnabled"
                  },
                  {
                    "kind": "Variable",
                    "name": "isDensityFull",
                    "variableName": "isDensityFull"
                  },
                  {
                    "kind": "Variable",
                    "name": "isEditableSyncLoaded",
                    "variableName": "isEditableSyncLoaded"
                  },
                  {
                    "kind": "Variable",
                    "name": "isInlineEditingEnabled",
                    "variableName": "isInlineEditingEnabled"
                  },
                  {
                    "kind": "Variable",
                    "name": "isLinkRelationshipFieldEnabled",
                    "variableName": "isLinkRelationshipFieldEnabled"
                  },
                  {
                    "kind": "Variable",
                    "name": "isTimelineEnabled",
                    "variableName": "isTimelineEnabled"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "IssueRow_fieldSets"
              },
              (v17/*: any*/)
            ]
          },
          (v19/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "progressSummary_issueViewChildIssuesPanel_statusAndResolved"
          },
          (v17/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v26/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.sourceIssueId"
                          },
                          {
                            "kind": "RequiredField",
                            "field": (v27/*: any*/),
                            "action": "THROW",
                            "path": "jira.searchViewContexts.edges.node.contexts.position"
                          },
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useGetRealtimeIssueDetailsQuery",
    "selections": [
      {
        "args": (v15/*: any*/),
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "jira_issuesByIds",
        "plural": true,
        "selections": [
          (v16/*: any*/),
          {
            "concreteType": "JiraParentIssueField",
            "kind": "LinkedField",
            "name": "parentIssueField",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v17/*: any*/)
                ]
              },
              (v20/*: any*/)
            ]
          },
          {
            "args": (v18/*: any*/),
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsById",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "fieldSetId"
                      },
                      {
                        "concreteType": "JiraIssueFieldConnection",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          {
                            "concreteType": "JiraIssueFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v30/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraAffectedServiceConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedAffectedServicesConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAffectedServiceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedService",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "serviceId"
                                                  },
                                                  (v34/*: any*/),
                                                  (v20/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraAffectedServicesField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraCascadingOption",
                                        "kind": "LinkedField",
                                        "name": "cascadingOption",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "parentOptionValue",
                                            "plural": false,
                                            "selections": (v36/*: any*/)
                                          },
                                          {
                                            "concreteType": "JiraOption",
                                            "kind": "LinkedField",
                                            "name": "childOptionValue",
                                            "plural": false,
                                            "selections": (v36/*: any*/)
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraCascadingSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraCmdbObjectConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedCmdbObjectsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbObjectEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "objectId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                  },
                                                  {
                                                    "concreteType": "JiraCmdbAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbMediaClientConfig",
                                                        "kind": "LinkedField",
                                                        "name": "mediaClientConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "clientId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaBaseUrl"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "mediaJwtToken"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "url48"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "message"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraCMDBField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "args": (v38/*: any*/),
                                        "concreteType": "JiraComponentConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedComponentsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraComponentEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponent",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/),
                                                  (v40/*: any*/),
                                                  (v20/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraComponentsField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v41/*: any*/),
                                      (v34/*: any*/),
                                      (v42/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraDatePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "dateTime"
                                      },
                                      (v34/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraDateTimePickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraEpic",
                                        "kind": "LinkedField",
                                        "name": "epic",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "color"
                                          },
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraEpicLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "renderedFieldHtml"
                                      }
                                    ],
                                    "type": "JiraFallbackField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v43/*: any*/),
                                      (v34/*: any*/),
                                      (v44/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraSingleLineTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatusCategory",
                                        "kind": "LinkedField",
                                        "name": "statusCategory",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v45/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusCategoryField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraStatus",
                                        "kind": "LinkedField",
                                        "name": "status",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "statusId"
                                          },
                                          (v46/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraStatusField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": (v38/*: any*/),
                                        "concreteType": "JiraLabelConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedLabelsConnection",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraLabelEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraLabel",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v34/*: any*/),
                                                  (v47/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "selectedLabelsConnection(first:1000)"
                                      },
                                      (v34/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraLabelsField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueType",
                                        "kind": "LinkedField",
                                        "name": "issueType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "small"
                                              }
                                            ]
                                          },
                                          (v34/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraIssueTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "parentIssue",
                                        "plural": false,
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "concreteType": "JiraColorField",
                                            "kind": "LinkedField",
                                            "name": "issueColorField",
                                            "plural": false,
                                            "selections": [
                                              (v47/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraIssueTypeField",
                                            "kind": "LinkedField",
                                            "name": "issueTypeField",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueType",
                                                "kind": "LinkedField",
                                                "name": "issueType",
                                                "plural": false,
                                                "selections": [
                                                  (v48/*: any*/),
                                                  (v34/*: any*/),
                                                  (v20/*: any*/)
                                                ]
                                              },
                                              (v20/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "JiraSingleLineTextField",
                                            "kind": "LinkedField",
                                            "name": "summaryField",
                                            "plural": false,
                                            "selections": [
                                              (v43/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          },
                                          (v20/*: any*/),
                                          (v16/*: any*/),
                                          (v49/*: any*/),
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Literal",
                                                    "name": "ids",
                                                    "value": [
                                                      "issuetype",
                                                      "project",
                                                      "summary",
                                                      "status"
                                                    ]
                                                  }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v32/*: any*/),
                                                          (v20/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v33/*: any*/),
                                                              (v43/*: any*/)
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v33/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v20/*: any*/),
                                                                  (v50/*: any*/),
                                                                  (v34/*: any*/),
                                                                  (v48/*: any*/),
                                                                  (v21/*: any*/)
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                          },
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v33/*: any*/),
                                                              {
                                                                "concreteType": "JiraStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v20/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraStatusCategory",
                                                                    "kind": "LinkedField",
                                                                    "name": "statusCategory",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v20/*: any*/),
                                                                      (v45/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "type": "JiraStatusField"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueTypeField",
                                                "kind": "LinkedField",
                                                "name": "issueTypeField",
                                                "plural": false,
                                                "selections": [
                                                  (v33/*: any*/),
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v50/*: any*/),
                                                      (v21/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraSingleLineTextField",
                                                "kind": "LinkedField",
                                                "name": "summaryField",
                                                "plural": false,
                                                "selections": [
                                                  (v33/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraStatusField",
                                                "kind": "LinkedField",
                                                "name": "statusField",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v33/*: any*/),
                                                  (v51/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v34/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraParentIssueField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "priority",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                          },
                                          (v20/*: any*/)
                                        ]
                                      },
                                      (v34/*: any*/),
                                      (v44/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraPriorityField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "project",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v19/*: any*/),
                                          {
                                            "concreteType": "JiraAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "large"
                                              }
                                            ]
                                          },
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraProjectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraResolution",
                                        "kind": "LinkedField",
                                        "name": "resolution",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraResolutionField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprintConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedSprintsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraSprintEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprint",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "sprintId"
                                                  },
                                                  (v34/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "state"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "endDate"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v34/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraSprintField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v32/*: any*/),
                                          (v34/*: any*/),
                                          (v52/*: any*/),
                                          (v53/*: any*/),
                                          (v20/*: any*/),
                                          (v54/*: any*/),
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isUser"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v55/*: any*/),
                                                "type": "AppUser"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": (v55/*: any*/)
                                              }
                                            ],
                                            "type": "AppUser"
                                          }
                                        ]
                                      },
                                      (v42/*: any*/),
                                      (v44/*: any*/),
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraSingleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraRichText",
                                        "kind": "LinkedField",
                                        "name": "richText",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraADF",
                                            "kind": "LinkedField",
                                            "name": "adfValue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAdfToConvertedPlainText",
                                                    "kind": "LinkedField",
                                                    "name": "convertedPlainText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "plainText"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "isDensityFull",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "json"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraRichTextField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraServiceManagementRequestType",
                                        "kind": "LinkedField",
                                        "name": "requestType",
                                        "plural": false,
                                        "selections": [
                                          (v34/*: any*/),
                                          (v48/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraServiceManagementRequestTypeField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                          }
                                        ],
                                        "concreteType": "JiraIssueLinkConnection",
                                        "kind": "LinkedField",
                                        "name": "issueLinkConnection",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          {
                                            "concreteType": "JiraIssueLinkEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssueLink",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "issue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v49/*: any*/),
                                                      (v19/*: any*/),
                                                      {
                                                        "args": [
                                                          {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                              "statusCategory"
                                                            ]
                                                          }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v32/*: any*/),
                                                                  {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                      (v46/*: any*/)
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                  },
                                                                  (v20/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          (v56/*: any*/)
                                                        ]
                                                      },
                                                      (v20/*: any*/)
                                                    ]
                                                  },
                                                  (v57/*: any*/),
                                                  (v20/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "issueLinkConnection(first:1)"
                                      }
                                    ],
                                    "type": "JiraIssueLinkField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "isStoryPointField"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "number"
                                      },
                                      (v34/*: any*/),
                                      (v37/*: any*/),
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "concreteType": "JiraNumberFieldFormatConfig",
                                            "kind": "LinkedField",
                                            "name": "formatConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "formatStyle"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "formatUnit"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraNumberField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraCommentSummary",
                                        "kind": "LinkedField",
                                        "name": "commentSummary",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "canAddComment"
                                          },
                                          (v31/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "JiraCommentSummaryField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "uri"
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraUrlField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "fieldOption",
                                        "plural": false,
                                        "selections": [
                                          (v35/*: any*/),
                                          (v47/*: any*/),
                                          (v20/*: any*/),
                                          (v58/*: any*/)
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraSingleSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedOptions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v35/*: any*/),
                                                  (v58/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraMultipleSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedOptions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v35/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraCheckboxesField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraUserConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedUsersConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraUserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v32/*: any*/),
                                                  (v54/*: any*/),
                                                  (v34/*: any*/),
                                                  (v52/*: any*/),
                                                  (v20/*: any*/),
                                                  (v53/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                      }
                                                    ],
                                                    "type": "AtlassianAccountUser"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraMultipleSelectUserPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraTeamView",
                                        "kind": "LinkedField",
                                        "name": "selectedTeam",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "jiraSuppliedId"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "jiraSuppliedName"
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraTeamViewField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraTimeTrackingField",
                                                "kind": "LinkedField",
                                                "name": "timeTrackingField",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v37/*: any*/),
                                                  (v59/*: any*/),
                                                  (v60/*: any*/),
                                                  (v33/*: any*/),
                                                  (v34/*: any*/),
                                                  (v30/*: any*/)
                                                ]
                                              },
                                              (v20/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraOriginalTimeEstimateField"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraTimeTrackingField",
                                                "kind": "LinkedField",
                                                "name": "timeTrackingField",
                                                "plural": false,
                                                "selections": [
                                                  (v59/*: any*/),
                                                  (v60/*: any*/),
                                                  (v20/*: any*/),
                                                  (v33/*: any*/),
                                                  (v34/*: any*/),
                                                  (v30/*: any*/)
                                                ]
                                              },
                                              (v20/*: any*/)
                                            ]
                                          },
                                          (v37/*: any*/)
                                        ],
                                        "type": "JiraOriginalTimeEstimateField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "selectedOption",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "label",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          (v20/*: any*/),
                                          (v39/*: any*/)
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraRadioSelectField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "args": (v38/*: any*/),
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedVersionsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraVersionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v34/*: any*/),
                                                  (v39/*: any*/),
                                                  (v40/*: any*/),
                                                  (v61/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "selectedVersionsConnection(first:1000)"
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraMultipleVersionPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      (v63/*: any*/),
                                      {
                                        "args": (v38/*: any*/),
                                        "concreteType": "JiraGoalConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedGoals",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraGoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGoal",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v19/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      (v34/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "status"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": "selectedGoals(first:1000)"
                                      },
                                      (v37/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "type": "JiraGoalsField"
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          (v63/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "isLinkEditable"
                                          },
                                          {
                                            "concreteType": "JiraTownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              {
                                                "alias": "atlasProjectName",
                                                "kind": "ScalarField",
                                                "name": "name"
                                              },
                                              {
                                                "alias": "atlasProjectKey",
                                                "kind": "ScalarField",
                                                "name": "key"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "privateProject"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "hasPermission"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "isWorkspaceActive"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconName"
                                              }
                                            ]
                                          },
                                          (v37/*: any*/)
                                        ],
                                        "type": "JiraTownsquareProjectField"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "args": (v38/*: any*/),
                                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                        "kind": "LinkedField",
                                        "name": "confluenceRemoteIssueLinks",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v64/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "pageContent",
                                                        "plural": false,
                                                        "selections": [
                                                          (v32/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              (v64/*: any*/)
                                                            ],
                                                            "type": "JiraConfluencePageContentDetails"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v31/*: any*/)
                                        ],
                                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraConfluenceRemoteIssueLinksField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "concreteType": "JiraGroupConnection",
                                        "kind": "LinkedField",
                                        "name": "selectedGroupsConnection",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraGroup",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v20/*: any*/),
                                                  (v34/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "groupId"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v37/*: any*/)
                                    ],
                                    "type": "JiraMultipleGroupPickerField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraFlag",
                                        "kind": "LinkedField",
                                        "name": "flag",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "isFlagged"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraFlagField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "JiraWatch",
                                        "kind": "LinkedField",
                                        "name": "watch",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "count"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "isWatching"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "JiraWatchesField"
                                  },
                                  {
                                    "condition": "isLinkRelationshipFieldEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v34/*: any*/),
                                          {
                                            "concreteType": "JiraIssueLink",
                                            "kind": "LinkedField",
                                            "name": "issueLink",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "direction"
                                              },
                                              (v57/*: any*/),
                                              {
                                                "concreteType": "JiraIssueLinkType",
                                                "kind": "LinkedField",
                                                "name": "type",
                                                "plural": false,
                                                "selections": (v62/*: any*/)
                                              }
                                            ]
                                          },
                                          (v44/*: any*/),
                                          (v37/*: any*/)
                                        ],
                                        "type": "JiraIssueLinkRelationshipTypeField"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "isTimelineEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v70/*: any*/),
                                        "type": "JiraTimelineField"
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v70/*: any*/),
                                        "type": "JiraAggregatedTimelineField"
                                      }
                                    ]
                                  },
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isConditionalFormattingEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "args": (v38/*: any*/),
                                            "concreteType": "JiraComponentConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedComponentsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraComponentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponent",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "componentId"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedComponentsConnection(first:1000)"
                                          }
                                        ],
                                        "type": "JiraComponentsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "priorityId"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraPriorityField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "projectId"
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraProjectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraVersion",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                              (v61/*: any*/),
                                              (v20/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraSingleVersionPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v50/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "selectedValue",
                                            "plural": false,
                                            "selections": (v71/*: any*/)
                                          }
                                        ],
                                        "type": "JiraSingleSelectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraSelectableValueConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedValues",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSelectableValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v71/*: any*/)
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraMultipleSelectField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v17/*: any*/)
            ]
          },
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "condition": "isHierarchyEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v20/*: any*/)
                    ]
                  }
                ]
              },
              (v22/*: any*/)
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v56/*: any*/),
              (v65/*: any*/)
            ]
          },
          (v17/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "JiraIssueSearchBulkViewContextsConnection",
            "kind": "LinkedField",
            "name": "searchViewContexts",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueSearchBulkViewContextsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "concreteType": "JiraIssueSearchBulkViewContextMapping",
                        "kind": "LinkedField",
                        "name": "contexts",
                        "plural": true,
                        "selections": [
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cd17bacbe1f9f25e59a66b6ead8ba1cc12eda34d08dfcb1424953180b0f23dae",
    "metadata": {},
    "name": "useGetRealtimeIssueDetailsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider": isJiraTimelineRollupsTechnicalGateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissueviewchildissuespanelrealtimeupdaterelayprovider": isIssueViewChildIssuesPanelRealtimeUpdateEnabled_provider
    }
  }
};
})();

(node as any).hash = "2a2eeea788a2e6bf9581e08300a2d126";

export default node;
